<template>
  <div class="dialog">
    <el-dialog
      :visible.sync="changVisible"
      title="权限选择"
      center
      width="746px"
      :before-close="$onClose"
      :destroy-on-close="true"
      @close="close()"
    >
      <div class="bodyParent">
        <el-table :data="apiListArray">
          <el-table-column width="690px">
            <template slot-scope="scope">
              <el-checkbox
                class="body"
                :indeterminate="isIndeterminate"
                v-model="scope.row.checkAll"
                @change="handleCheckAllChange(scope.row)"
                >{{ scope.row.name }}-全选</el-checkbox
              >
              <el-checkbox-group
                v-model="checkedList"
                @change="handleCheckedChange"
              >
                <el-checkbox
                  v-for="api in scope.row.api_list"
                  :label="api.api_cn"
                  :key="api.id"
                  >{{ api.api_other_cn }}</el-checkbox
                >
              </el-checkbox-group>
            </template>
          </el-table-column>
        </el-table>

        <div class="footDialog">
          <el-button
            style="float: right"
            size="small"
            type="primary"
            @click="save()"
            >保存</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as Utils from "@/utils/utils.js";
import * as StrUtils from "@/utils/strUtils.js";

export default {
  data() {
    return {
      changVisible: false,
      addPower: false,
      isIndeterminate: false,
      checkedList: [],
      checkedListTemp: [],
      apiIdList: [],
    };
  },
  props: ["apiListArray"],
  methods: {
    handleCheckAllChange(row) {
      row.api_list.forEach((api) => {
        var index = this.checkedList.indexOf(api.api_cn);
        if (index >= 0) {
          this.checkedList.splice(index, 1);
        }
      });
      if (row.checkAll) {
        row.api_list.forEach((api) => {
          this.checkedList.push(api.api_cn);
        });
      }
      this.setCheckedListTemp();
    },
    handleCheckedChange(value) {
      let put = this.checkedList.length > this.checkedListTemp.length;
      let click = Utils.getArrDifference(
        this.checkedList,
        this.checkedListTemp
      )[0];
      // console.log(click + " put:" + put);
      this.apiListArray.forEach((array, index) => {
        let count = array.api_list.length;
        let size = 0;
        let show = false;
        if (put) {
          array.api_list.forEach((api, index) => {
            let showStr = array.api_list[0].api_cn;
            if (
              click === api.api_cn &&
              this.checkedList.indexOf(showStr) === -1
            ) {
              this.checkedList.push(showStr);
            }
          });
        }
        array.api_list.forEach((api, index) => {
          if (index === 0 && this.checkedList.indexOf(api.api_cn) >= 0) {
            show = true;
          }
          if (show) {
            if (this.checkedList.indexOf(api.api_cn) >= 0) {
              size++;
            }
          } else {
            var index = this.checkedList.indexOf(api.api_cn);
            if (index >= 0) {
              this.checkedList.splice(index, 1);
            }
          }
        });
        this.$set(this.apiListArray[index], "checkAll", count === size);
      });
      this.setCheckedListTemp();
    },

    $onClose(done) {
      done();
    },
    //页面初始化时加载的事件
    show(addPower, apiIds) {
      this.addPower = addPower;
      if (StrUtils.isEmpty(apiIds)) {
        this.apiIdList = [];
      } else {
        this.apiIdList = apiIds.split(",");
      }
      this.showSelectPower();
      this.changVisible = true;
    },
    close() {
      this.changVisible = false;
      this.resetData();
    },
    // 保存
    save() {
      const ids = this.getPowerIds();
      this.$emit("toSave", this.addPower, ids);
      this.changVisible = false;
    },
    // 临时数组赋值
    setCheckedListTemp() {
      this.checkedListTemp = [];
      this.checkedList.forEach((check) => {
        this.checkedListTemp.push(check);
      });
    },
    // 重置数据
    resetData() {
      this.checkedListTemp = [];
      this.checkedList = [];
      this.apiListArray.forEach((array) => {
        array.checkAll = false;
      });
    },
    getPowerIds() {
      var ids = "";
      this.apiListArray.forEach((array) => {
        array.api_list.forEach((api) => {
          if (this.checkedList.indexOf(api.api_cn) >= 0) {
            ids += api.id + ",";
          }
        });
      });
      return ids.substring(0, ids.length - 1);
    },
    // 显示勾选权限
    showSelectPower() {
      console.log(this.checkedList);
      console.log(this.apiIdList);
      if (this.apiIdList === undefined) return;
      this.checkedList = [];
      this.apiListArray.forEach((array, index) => {
        let count = array.api_list.length;
        let size = 0;
        array.api_list.forEach((api) => {
          if (this.apiIdList.indexOf(api.id + "") >= 0) {
            console.log(api.id);
            this.checkedList.push(api.api_cn);
            size++;
            // console.log(size);
          }
        });
        this.$set(this.apiListArray[index], "checkAll", count === size);
      });
      console.log(this.checkedList);
      this.setCheckedListTemp();
    },
  },
};
</script>

<style lang="less" scoped>
.body {
  margin-top: 20px;
  background-color: transparent;
}
</style>

 <style lang="less">
.el-dialog--center .el-dialog__body {
  text-align: initial !important;
  padding: 25px 25px 30px !important;
}
</style> 



// WEBPACK FOOTER //
// src/components/dialog/rolePowerDialog.vue